import React from 'react';
import { Helmet } from 'react-helmet';
import { toUpperCase } from '../constants/strings';

export const SEO = ({ title, metaDescription, slug }) => {
	const schemaCor = {
		'@context': 'http://schema.org',
		'@type': 'Corporation',
		'@id': `https://corporation.thad.ca`,
		url: 'https://thad.ca',
		legalName: 'THAD Inc',
		alternateName: 'THAD',
		description: 'THAD is a residential design studio, creating functional, innovative, custom dwellings.',
		address: {
			'@type': 'PostalAddress',
			addressLocality: 'Calgary',
			addressCountry: 'CA',
			postalCode: 'T2G 0V9',
			streetAddress: '221 10 Ave SE #100'
		},
		logo:
			'https://firebasestorage.googleapis.com/v0/b/thad-e0db3.appspot.com/o/favicon.png?alt=media&token=bbd73f80-277f-4ec1-b092-ae42f426be97',
		sameAs: [ 'https://www.instagram.com/thad.ca/', 'https://ca.linkedin.com/in/tyler-hawryluk-b362ab83' ],
		additionalType: 'http://www.productontology.org/doc/Architect',
		telephone: '+4038809629'
	};

	const schemaOrgWebPage = {
		'@context': 'http://schema.org',
		'@type': 'WebPage',
		url: `https://thad.ca${slug}`,
		headline: title,
		inLanguage: 'en',
		mainEntityOfPage: `https://corporation.thad.ca`,
		description: metaDescription,
		name: title,
		author: {
			'@type': 'Corporation',
			name: 'Tyler Hawryluk Architectural Design Inc'
		},
		copyrightHolder: {
			'@type': 'Corporation',
			name: 'Tyler Hawryluk Architectural Design Inc'
		},
		copyrightYear: '2019',
		creator: {
			'@type': 'Corporation',
			name: 'Tyler Hawryluk Architectural Design Inc'
		},
		publisher: {
			'@type': 'Corporation',
			name: 'Tyler Hawryluk Architectural Design Inc'
		},
		datePublished: new Date(1561657098000),
		dateModified: new Date(),
		image: {
			'@type': 'ImageObject',
			url:
				'https://firebasestorage.googleapis.com/v0/b/thad-e0db3.appspot.com/o/favicon.png?alt=media&token=bbd73f80-277f-4ec1-b092-ae42f426be97'
		}
	};

	return (
		<Helmet title={`${title ? `${toUpperCase(title)} - ` : ''}THAD`}>
			<meta name='description' content={metaDescription} />
			<meta property='og:title' content={`${title ? `${toUpperCase(title)} - ` : ''}THAD`} />
			<meta property='og:description' content={metaDescription} />
			<meta property='og:type' content={'website'} />
			<meta
				property='og:image'
				content={
					'https://firebasestorage.googleapis.com/v0/b/thad-e0db3.appspot.com/o/favicon.png?alt=media&token=bbd73f80-277f-4ec1-b092-ae42f426be97'
				}
			/>
			<meta property='og:site_name' content={'THAD'} />
			<meta property='og:url' content={`https://thad.ca${slug}`} />

			{/* <meta name='twitter:card' content='summary_large_image' />
			<meta name='twitter:creator' content={'@latticestudios'} />
			<meta
				name='twitter:image'
				content={
					'https://firebasestorage.googleapis.com/v0/b/lattice-studios.appspot.com/o/favicon.png?alt=media&token=eaaf4f22-773a-4425-a0da-c52ce3a74c02'
				}
			/>
			<meta name='twitter:title' content={`${title ? `${toUpperCase(title)} - ` : ''}Lattice Studios`} />
			<meta name='twitter:description' content={metaDescription} />
			<meta name='twitter:site' content={'Lattice Studios'} /> */}

			<script type='application/ld+json'>{JSON.stringify(schemaCor)}</script>
			<script type='application/ld+json'>{JSON.stringify(schemaOrgWebPage)}</script>
		</Helmet>
	);
};
